<template>
	<div style="width: 100%">
		<div class="header">
			<div @click="backJump" style="color: #fff;padding-top: 10px;margin-left: 10px;">
				<span style="line-height: 30px;"><i class="van-icon van-icon-arrow-left van-nav-bar__arrow"></i>返回</span>
			</div>
			<div class="clear"></div>
			<img src="../assets/topback.png" style="width: 50%;height: 75%;float: right;margin-top: -10px;" alt="">
			<div>
				<h2><span>用</span>量记录</h2>
			</div>
		</div>
		<div class="content" style="position: relative;">
			<div class="center">
				<div class="center_al">
					<div class="bt">
						<img src="../assets/dian.png" >
						<span>电费</span>
					</div>
					<div class="cont_top">
						<div>
							<span class="left">{{title}}</span><span class="right" style="font-weight: bold;">{{shz}}</span>
						</div>
						<div>
							<span class="left">识别编码信息</span><span class="right">{{account}}</span>
						</div>
						<div>
							<span class="left">住址信息</span><span class="right">{{address}}</span>
						</div>
					</div>
				</div>
				
			</div>
			<div class="cont_center">
				<div class="center_con">
					<p>使用明细（千瓦时）</p>
          <van-tabs v-model:active="tabChange" type="card" @change="bodyChange">
            <van-tab title="月用电费"></van-tab>
            <van-tab title="日用电费">
              <van-tabs v-model="dateTime" shrink @change="timeChange">
                <van-tab title="7天">
                </van-tab>
                <van-tab title="30天">
                </van-tab>
              </van-tabs>
            </van-tab>
          </van-tabs>
					<div id="main" style="width: 100%;height: 300px;"></div>
					<div :style="tian">
						<ul class="day" >
							<li style="color: #8E8E8E;height: 27px;text-align: center;">
								<div style="float: left;width: 50%;background-color: #EFF1F0 ;line-height: 27px;">
									<span>时间</span>
								</div>
								<div style="float: left;width: 50%;background-color: #EFF1F0 ;line-height: 27px;">
									<span>电量（千瓦时）</span>
								</div>
							</li>
							<li v-for="item in all" style="height: 27px;margin-top:20px;text-align: center;border-bottom: 1px solid #DEE1E5;">
								<div style="float: left;width: 50%;line-height: 27px;">
									<span style="color: #8E8E8E;">{{item.billTimestamp}}</span>
								</div>
								<div style="float: left;width: 50%;line-height: 27px;">
									<span>{{item.usedTotal}}</span>
								</div>
							</li>
							<li style="height: 27px;;margin-top:20px;text-align: center;">
								<div style="float: left;width: 50%;text-align: center;line-height: 27px;">
									<span>合计</span>
								</div>
								<div style="float: left;width: 50%;line-height: 27px;">
									<span>{{total}}</span>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import * as echarts from 'echarts';
  import {dayMon, usage} from "../common/api/balance";
  import jump from "../common/jump";
	export default{
		data(){
			return{
				yue:{
					display:'none'
				},
				tian:{
					display:'block'
				},
				all:[],
				title:'当前余额',
				shz:'',
				butcolweek:{
					backgroundColor:'#4e9df9',
					color:'#fff'
				},
				butcolmonth:{
					backgroundColor:'#fff',
					color:'#000'
				},
        tabChange:0,
				total:'',
        echartShow:true,
				month:{
					color:'#95c4fb',
					width:'80px',
					height:'30px',
					backgroundColor:'#4e9df9',
					borderRadius:'50px',
					marginTop:'5px',
					marginLeft:'14px',
					textAlign:'center',
					lineHeight:'30px'
				},
				day:{
					color:'#0f72dd',
					width:'80px',
					height:'30px',
					backgroundColor:'#fff',
					borderRadius:'50px',
					marginTop:'5px',
					marginLeft:'14px',
					textAlign:'center',
					lineHeight:'30px'
				},
				account:'',
				address:'',
				payer:'',
				dayfa:[
				],
				ycontent:{},
				startTime:'',
				endTime:'',
				dats:[],
        dateTime:0,
        echContent:[]
			}
		},
		mounted() {
			this.account = this.$route.query.houseHold
			this.address = this.$route.query.address
      this.title = this.$route.query.text
      if(this.title == "剩余电量："){
        this.shz = this.$route.query.balance + 'kw/h'
      }else if(this.title == "剩余金额："){
        this.shz = this.$route.query.balance + '元'
      }
      this.echart()
      this.months()
      // this.timeChange()
		},
		methods:{
      timeChange(){
        if(this.dateTime == 0){
          this.startend(7)
          this.everydate(7)
        }else{
          this.startend(30)
          this.everydate(30)
        }
        usage({houseHoldNumber:this.account, startTime:this.startTime, endTime:this.endTime}).then((response)=>{
          this.all = response.data.items

          console.log(this.all)
          let con = []
          let time = []
          for(let i =0;i<response.data.items.length;i++){
            let dats = response.data.items[i].billTimestamp.split(' ')
            response.data.items[i].billTimestamp = dats[0]
            time.push(response.data.items[i].billTimestamp.split('-')[1]+ "." +response.data.items[i].billTimestamp.split('-')[2])
            con.push(response.data.items[i].usedTotal)
          }
          this.ycontent = time
          this.echContent = con
          this.totalMeth(this.all)
          this.echart()
        })
      },
      bodyChange(){
        if(this.tabChange == '0'){
          this.echartShow = true
          this.months()
        }
        else{
          this.echartShow = false
          this.dateTime = 0
          this.timeChange()
        }
      },
      backJump(){
        this.$destroy()
        jump.$emit('back')
        this.$router.go(-1)
      },
			startend(shij){
        var tempDate = new Date() // 获取今天的日期
        tempDate.setDate(tempDate.getDate() - shij) // 今天的前N天的日期，N自定义
        let time = new Date(tempDate.getFullYear() + '/' + (tempDate.getMonth() + 1) + '/' + tempDate.getDate() + " 00:00:00").getTime()
				this.startTime = time
        let endt = new Date()
        endt.setDate(endt.getDate() - 0) // 今天的前N天的日期，N自定义
        let tim = new Date(endt.getFullYear() + '/' + (endt.getMonth() + 1) + '/' + endt.getDate() + " 00:00:00").getTime()
				this.endTime = tim
			},
			echart(){
				var myChart = echarts.init(document.getElementById('main'));
				var option;
        myChart.clear()
        option  = {
          xAxis: {
            type: 'category',
            data: this.ycontent,
            axisLabel:{
              interval: 0,
              rotate:45
            },
          },
          grid:{
            left:'13%'
          },
          yAxis: {
            type: 'value',
            zlevel:10001
          },
          series: [
            {
              data: this.echContent,
              type: 'line'
            }
          ]
        }
				myChart.setOption(option);
			},
			echartDay(){
				var myChart = echarts.init(document.getElementById('mainDay'));
				var option;
        option  = {
          xAxis: {
            type: 'category',
            data: this.ycontent,
            axisLabel:{
              interval: 0,
              rotate:45
            },
          },
          yAxis: {
            type: 'value'
          },
          grid:{
            left:'10%'
          },
          series: [
            {
              data: this.echContent,
              type: 'line'
            }
          ]
        }
				myChart.setOption(option);
			},
      // 月用电费
			months:function(){
				this.startend(180)
        dayMon({houseHoldNumber:this.account,startTime:this.startTime,endTime:this.endTime}).then((response)=>{
          let con = []
          let time = []
				  for(let i =0;i<response.data.items.length;i++){
            let dats = response.data.items[i].billTimestamp.split(' ')
            response.data.items[i].billTimestamp = dats[0]
            time.push(response.data.items[i].billTimestamp.split('-')[1] + "月")
            con.push(response.data.items[i].usedTotal)
				  }
          this.ycontent = time
				  this.all = response.data.items
          this.totalMeth(this.all)
          this.echContent = con
				  this.echart()
				})
			},
			everydate:function(day){
				var myDate = new Date() // 获取今天日期
        myDate.setDate(myDate.getDate() - day-1)
        var dateArray = []
        var dateTemp
        var flag = 1
        for (var i = 0; i < day; i++) {
          dateTemp = (myDate.getMonth() + 1) + '-' + myDate.getDate()
          dateArray.push(dateTemp)
          myDate.setDate(myDate.getDate() + flag)
        }
        // this.ycontent = dateArray
			},

      totalMeth(param){
        let total = 0
        for(let i =0;i<param.length;i++) {
          var r1, r2, m;
          try {
            r1 = total.toString().split(".")[1].length;
          } catch (e) {
            r1 = 0;
          }
          try {
            r2 = param[i].usedTotal.toString().split(".")[1].length;
          } catch (e) {
            r2 = 0;
          }
          m = Math.pow(10, Math.max(r1, r2));
          total =  (total * m + param[i].usedTotal * m) / m;
        }
        this.total = total
      },
		},
		filters: {
		      formatDate: function (value) {
		        let date = new Date(value);
		        let y = date.getFullYear();
		        let MM = date.getMonth() + 1;
		        MM = MM < 10 ? ('0' + MM) : MM;
		        let d = date.getDate();
		        d = d < 10 ? ('0' + d) : d;
		        let h = date.getHours();
		        h = h < 10 ? ('0' + h) : h;
		        let m = date.getMinutes();
		        m = m < 10 ? ('0' + m) : m;
		        let s = date.getSeconds();
		        s = s < 10 ? ('0' + s) : s;
		        return y + '.' + MM + '.' + d;
		      },
			  formatMonth: function (value) {
			    let date = new Date(value);
			    let y = date.getFullYear();
			    let MM = date.getMonth() + 1;
			    MM = MM < 10 ? ('0' + MM) : MM;
			    let d = date.getDate();
			    d = d < 10 ? ('0' + d) : d;
			    let h = date.getHours();
			    h = h < 10 ? ('0' + h) : h;
			    let m = date.getMinutes();
			    m = m < 10 ? ('0' + m) : m;
			    let s = date.getSeconds();
			    s = s < 10 ? ('0' + s) : s;
			    return y + '.' + MM ;
			  },
			}
	}
</script>

<style scoped>
	.header{
		width: 100%;
		height: 192px;
		background-color: #295ad0;
	}
	
	.header h2{
		letter-spacing:2px;
		color: rgb(255, 255, 255);
		line-height: 50px;
		position: relative;
		margin-left:20px
	}
	.header h2 span{
		border-bottom: 3px solid #fff;
	}
	.center{
		width: 90%;
		height: 350px;
		margin: 0 auto;
		border:1px solid #dee1e5;
		box-shadow: #dee1e5 0px 0px 1px 1px;
		border-radius: 10px;
		margin-top:-20px;
		background-color: #fff;
	}
	.center_al{
		width: 90%;
		margin: 0 auto;
	}
	.bt{
		margin-top:20px
	}
	.bt img{
		width: 38px;
		height:38px;
		float: left;
	}
	.bt span{
		line-height: 42px;
		margin-left: 10px;
		font-size: 20px;
	}
	.bt p{
		color:#0f72dd
	}
	.cont_top{
		margin-top:20px
	}
	.cont_top div{
		height: 30px;
		margin-top: 35px;
		border-bottom: 1px solid #dee1e5;
	}
	.cont_top div .left{
		color:#8e8e8e;
		float: left;
	}
	.cont_top div .right{
		color:#000;
		float: right;
	}
	.cont_center{
		width: 90%;
		margin: 0 auto;
		border:1px solid #dee1e5;
		box-shadow: #dee1e5 0px 0px 1px 1px;
		border-radius: 10px;
		margin-top:20px;

	}
	.center_con{
		width:90%;
		margin: 0 auto;
		padding-top: 10px;
	}
	.center_con p{
		color:#0f72dd;
	}
	.btnal{
		width:200px;
		background-color: #4e9df9;
		height:40px;
		border-radius: 50px;
		margin: 0 auto;
	}
	.btnal div{
		float: left;
	}
  .van-tab__pane, .van-tab__pane-wrapper{
    width: 50%;
  }
  /deep/.van-tabs__nav--card .van-tab.van-tab--active{
    background-color: #629bf2
  }
  /deep/.van-tabs__nav--card .van-tab.van-tab--active{
    color:#fff
  }
  /deep/.van-tabs__nav--card .van-tab{
    color: #a6c9ff
  }
  /deep/ .van-tabs__nav--card{
    border: 1px solid #629bf2;
  }
  /deep/ .van-tabs__nav--card .van-tab{
    border-right: none;
  }
  /deep/ .van-tabs__line{
    background-color: #629bf2;
  }
</style>
